// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1g9gm","colMaxWidth":"Table_colMaxWidth__394us"};